export const getSearchInputTemplate = () => {
	return `
    <form role="search" class="search-form" method="get" action="?" autocomplete="off">
      <input type="text" id="s" class="search-form__term" name="s" placeholder="{{placeholder}}">
      <div class="search-form__clear"></div>
    </form>
  `;
};
